import SupervisingScreen from "@/app/(app)/(crew)/supervising/index";

export default SupervisingScreen;
